export default {
    headerCard: {
        title: 'Build your Questionnaire',
        description:
            'Choose how you want to build your questionnaire - start from scratch or use one of our proven templates',
    },
    chooseFromTemplates: 'Choose from Templates',
    startFromScratch: {
        title: 'Start a questionnaire from Scratch',
        description: 'Build a custom evaluation from scratch with complete control over questions.',
        questionTitle: 'New Questionnaire',
    },
    startBuilding: 'Start Building',
    useTemplate: 'Use Template',
    illustrationAlt: 'Illustration of creating an evaluation',
    browseMoreTemplates: 'Browse More Templates',
    validation: {
        templateValidation: 'Please select at least one template to proceed to the next step.',
    },
    switchTemplateConfirm: {
        title: 'Switch Template',
        message:
            "You are about to switch templates. All existing questions will be permanently removed and replaced with the new template's questions.",
        confirm: 'Proceed',
        cancel: 'Cancel',
    },
};
